import { useEffect } from 'react';

/**
 * The old root-host diagnostic pages (/diagnostic, /admin-tools,
 * /database-diagnostic, /data-diagnostic) are System Admin › Operations now
 * (RESTORE_PLAN R3.6). Their addresses keep working: they land there, and a
 * signed-out visitor meets the system-admin sign-in first.
 */
export const OPERATIONS_URL = '/system-admin?tab=operations';

export function LegacyAdminRedirect({ to = OPERATIONS_URL }: { to?: string }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-muted-foreground">This tool is in System Admin › Operations now. Taking you there…</p>
    </div>
  );
}
